module.exports = __webpack_public_path__ + "static/media/bg-mletter-header-top.5bfc20bb.svg";